import React, { Component } from 'react';
import { imageBasePath } from '../../constants/staticData';
export default class ServiceTypeEmptyState extends Component {

    render() {
        return (
            <div >
                <div className="empty-state-holder">
                    <span className="empty-state-content">
                        <img src={`${imageBasePath}/images/search_empty.png`} alt="" />
                        <span className="text">Oops! We couldn’t find what you were looking for </span>
                    </span>
                </div>
            </div>
        );
    }
}
